export function formatNumberByLanguage(
  value: number,
  language: string | undefined
) {
  return new Intl.NumberFormat(language).format(value);
}
